import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li>Notes</li>
          <li className="active">Videos</li>
          <li>Stories</li>
          <li className="">Sprint</li>
          <li className="">Mind Tree</li>
          <li className="">Geek Corner</li>
          <li className="">Echoes</li>
        </ul>
        <div className="tab__content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="prime-head p-0 boldtitle">Test Sub Lesson1</h2>
                <span className="boldtitle mt-5 conaddtitle">Add New Video</span>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="w-100 mt-4">
                  <label htmlFor="">Video Title</label>
                  <input type="text" placeholder="Enter" />
                </div>
                <div className="w-100 mt-4">
                  <label htmlFor="">Video Description</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
                <div className="w-100 mt-4 ">
                  <label htmlFor="">Video Search Tags</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
              </div>

              <div className="col-lg-5 col-md-6  col-sm-12 videochoosefrom ">
                <div className="w-100 mt-4">
                  <label htmlFor="">
                    <span className="radioBlock">
                      <input id="test1" name="test" value="2" type="radio" />
                      <label htmlFor="test1"></label>
                    </span>
                    Choose from Library
                  </label>
                  <select required>
                    <option value="" selected="" disabled="">
                      Choose
                    </option>
                    <option value="1">Test</option>
                    <option value="2">Test</option>
                    <option value="3">Test</option>
                  </select>
                </div>
                <div className="w-100 mt-5 tab-nmp">
                  <label className="w-100" htmlFor="">
                    <span className="radioBlock">
                      <input id="test2" name="test" value="1" type="radio" />
                      <label htmlFor="test2"></label>
                    </span>
                    Choose from this Local Machine
                  </label>
                  <button className="btn-right-content upload">Upload</button>
                </div>
                <div className="w-100 mt-4">
                  <label htmlFor="">
                    <span className="radioBlock">
                      <input id="test3" name="test" value="3" type="radio" />
                      <label htmlFor="test3"></label>
                    </span>
                    Enter Hosted Video URL
                  </label>
                  <input type="text" placeholder="Enter" />
                </div>
              </div>
            </div>
            <div className="row mt-5 btnsubmitmain">
              <div className="col-12 btnTab-foot">
                <button className="btn-right-content save">Save Changes</button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <span className=" col-12  mt-5 mb-5 conaddtitle boldtitle">Uploaded Videos</span>

                <div className="ratio ratio-21x9">
                  <iframe
                    src="//www.youtube.com/embed/YE7VzlLtp-4"
                    title="YouTube video"
                    allowfullscreen
                  ></iframe>
                  <label className="videotitlename">Video Title</label>
                </div>
                <div className="ratio ratio-21x9">
                  <iframe
                    src="//www.youtube.com/embed/YE7VzlLtp-4"
                    title="YouTube video"
                    allowfullscreen
                  ></iframe>
                  <label className="videotitlename">Video Title</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
